export enum PLAN_SIZE {
	INDIVIDUAL = 'individual',
	FAMILY = 'family'
}

export const getPlanSizeName = (size: PLAN_SIZE): string => {
	return size === PLAN_SIZE.FAMILY ? 'Family' : 'Individual';
};
